import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export const APP_TZ = "Asia/Dubai";

export function fmtDate(iso) {
  if (!iso) return "—";
  return dayjs(iso).tz(APP_TZ).format("DD MMM YYYY HH:mm");
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  return dayjs(iso).fromNow();
}

export function fmtUSD(n) {
  if (n == null) return "—";
  return `$${Number(n).toFixed(2)}`;
}

export function fmtECU(n) {
  if (n == null) return "—";
  return `${Number(n).toFixed(2)} ECU`;
}

export function fmtECUWithUSD(ecu, usdPerEcu) {
  if (ecu == null) return "—";
  const e = Number(ecu);
  const rate = Number(usdPerEcu || 0);
  const usd = e * rate;
  if (!rate) return `${e.toFixed(2)} ECU`;
  return `${e.toFixed(2)} ECU (~ $${usd.toFixed(2)})`;
}

export function fmtPct(n) {
  if (n == null) return "—";
  return `${Number(n).toFixed(0)}%`;
}

export function fmtRateUsdPerEcu(r) {
  if (r == null) return "—";
  return `$${Number(r).toFixed(4)} / ECU`;
}
